import { API } from './constant';
import { HttpRequest } from '../../lib/http';

export const actionExchange = (id: number) => {
  return HttpRequest({
    method: API.TYPE,
    url: API.URL(id),
  });
};
